import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Box, Button, Grid, Typography } from '@mui/material'
import { format } from 'date-fns'

import { useGET_academicPeriodsQuery } from 'redux/api/academicPeriodsApi'
import { useGET_milestonesQuery } from 'redux/api/milestonesApi'

import BoxTitle from 'components/atoms/BoxTitle'
import { CalendarMonth } from '@mui/icons-material'
import { useSelector } from 'react-redux'
import { RootState } from 'redux/store'

const AcademicCalendar: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const user = useSelector((state: RootState) => state['user'].user)

  const today = format(new Date(), 'yyyy-MM-dd')
  const { data: academicPeriods } = useGET_academicPeriodsQuery({
    page: 1,
  })
  const { data: milestones } = useGET_milestonesQuery({
    page: 1,
    start_date_from: today,
  })

  const list = []

  milestones?.results.forEach((milestone) => {
    list.push({
      key: milestone.id,
      academicPeriodId: milestone.academic_period_id,
      title: `${milestone?.title}`,
      start: format(new Date(milestone.start_date), 'MMM d'),
      end:
        milestone.end_date && milestone.end_date !== milestone.start_date
          ? format(new Date(milestone.end_date), 'MMM d')
          : null,
    })
  })

  return (
    <Box className="transparent-background">
      <Grid container spacing={1}>

        <Grid item xs={9}>
          <BoxTitle title={`${t('school.academic-calendar')}`} text={''} icon={<CalendarMonth />} />
          <div style={{ paddingLeft: '36px' }}>2024/2025</div>
        </Grid>

        {!['parent','student'].includes(user?.role) &&
        <Grid item xs={3} textAlign={'right'}>
          <Button
                variant='outlined'
                color='black'
                onClick={() => window.location.href = '/milestones'}
                className='small-button'
              >
                {`${t('common.view-all')}`}
           </Button>
        </Grid>
        }


        <Grid item xs={12}>
          <Grid container>
          {academicPeriods?.results.filter(period => list.filter(item => item.academicPeriodId === period.id).length > 0).map((period, index) => {
            return (
              <Grid item xs={6} sm={4} md={6} key={period.id}>
                <Box className="transparent-background">
                  <Typography
                    sx={{
                      fontFamily: 'NewsReader',
                      fontWeight: '600',
                      fontSize: '1rem',
                      marginTop: 2,
                      marginBottom: 1,
                    }}
                  >
                    {' '}
                    {`${period.title}`}
                  </Typography>
                  {list.filter(item => item.academicPeriodId === period.id).map((item, i) =>
                      <Box className="transparent-background" key={period.id + '-' + item.key} sx={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                        <div style={{ 
                          background: '#bff3f4',
                          borderRadius: '10px',
                          display: 'inline-block',
                          padding: '5px 5px',
                          width: '50px',
                          marginRight: '5px',
                          fontSize: '0.7rem',
                          textAlign: 'center'
                        }}>{`${item.start}`}</div>  {/*  {item.end ? ` - ${item.end}` : ''} */}
                        <span style={{ fontSize: '0.7rem' }}>{`${item.title}`}</span>
                      </Box>
                  )}
                </Box>
              </Grid>
            )
          })}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}

export default AcademicCalendar
